<template>
  <div class="compare-value">
    <el-input
      v-if="!compareMethod || noValCompareMethod.includes(compareMethod)"
      class="value-content main-value"
      disabled
    ></el-input>

    <section
      v-else
      :class="{
        'value-content': true,
        'has-flow-var-button': addFlowVarBtnVisible
      }"
    >
      <!--当前变量已选中工作流变量-->
      <div
        v-if="_.isString(localValue) && valueVarMap[localValue] && control._type !== 'time'"
        class="var-container main-value"
        :class="size"
      >
        <span class="var">{{ varLabelMap[localValue] }}</span>
        <div class="icon-close" @click="emitVal()">
          <i class="el-icon-close"></i>
        </div>
      </div>
      <template v-else-if="compareType == 'String'">
        <address-selector
          v-if="'address' === control._type"
          :value="localValue"
          @input="emitVal"
          :disabled="disabled"
          :level="control.level"
          check-strictly
          class="main-value"
        ></address-selector>
        <dm-select
          v-else
          :value="nextTickValue || []"
          @input="emitVal"
          :disabled="disabled"
          multiple
          filterable
          clearable
          allow-create
          :size="size"
          default-first-option
          remote
          :remote-method="remoteMethod"
          placeholder="请输入"
          no-data-text="请输入后再选择"
          class="main-value"
        >
          <el-option
            v-for="item in allOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </dm-select>
      </template>
      <template v-else-if="compareType == 'Number'">
        <template v-if="['time', 'date'].includes(control._type)">
          <el-select
            v-if="compareMethod == '在期间'"
            :value="localValue"
            @input="emitVal"
            :disabled="disabled"
            class="main-value"
            :size="size"
          >
            <el-option
              v-for="item in timeRange"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <el-input
            v-else-if="['前...天内', '后...天内'].includes(compareMethod)"
            :disabled="disabled"
            type="number"
            :value="localValue"
            @input="emitVal"
            class="main-value"
            :size="size"
          ></el-input>
          <div
            class="time-wrapper"
            v-else
            :class="disabled ? 'disabled' : ''"
            @click="openTimeSelect"
          >
            <div class="time-tip">
              <template v-if="!showTime">
                <i class="el-icon-plus"></i>
                选择日期时间
              </template>
              <template v-else>{{ showTime }}</template>
            </div>
            <div v-if="showTime" class="icon-close" @click.stop="emitVal()">
              <i class="el-icon-close"></i>
            </div>
          </div>
        </template>
        <el-input
          v-else
          :disabled="control._dataType === 'bool' ? true : disabled"
          type="number"
          class="main-value"
          :value="localValue"
          @input="emitVal"
          :size="size"
        ></el-input>
      </template>
      <template v-else-if="compareType == 'Select'">
        <template v-if="['staff', 'department', 'company'].includes(control._type)">
          <div v-if="control._type == 'staff'" class="main-value">
            <user-selector
              v-if="_.isEmpty(dropdownVarList)"
              :value="localValue"
              @input="emitVal"
              multiple
              :disabled="disabled"
              clearable
            ></user-selector>
            <select-scope
              v-else
              title="选择人员"
              multiple
              :var-group="dropdownVarList"
              :show-department-tab="false"
              show-user-tab
              :value="localValue"
              @input="emitVal"
            ></select-scope>
          </div>
          <div v-else-if="control._type == 'department'" class="main-value">
            <department-selector
              v-if="_.isEmpty(dropdownVarList)"
              :value="localValue"
              @input="emitVal"
              multiple
              :disabled="disabled"
              clearable
              :from="departFrom"
            ></department-selector>
            <select-scope
              v-else
              title="选择部门"
              multiple
              :var-group="dropdownVarList"
              show-department-tab
              :show-user-tab="false"
              :value="localValue"
              @input="emitVal"
            ></select-scope>
          </div>
          <div v-else-if="control._type == 'company'">
            <company-selector
              v-if="_.isEmpty(dropdownVarList)"
              :value="localValue"
              @input="emitVal"
              multiple
              clearable
              :disabled="disabled"
              class="main-value"
            ></company-selector>
            <select-scope
              v-else
              title="选择企业"
              multiple
              :var-group="dropdownVarList"
              :show-department-tab="false"
              :show-user-tab="false"
              :additional-tabs="selectScopeAdditionalTabs"
              :value="localValue"
              @input="emitVal"
            ></select-scope>
          </div>
        </template>
        <template v-else-if="['rids', 'crids'].includes(control._cid)">
          <normal-select
            class="main-value"
            :select-list="roles"
            :selected-item="localValue"
            @update:selectedItem="emitVal"
            multiple
          ></normal-select>
        </template>
        <template v-else>
          <var-group-selector
            v-if="!_.isEmpty(dropdownVarList)"
            :value="value"
            @input="emitVal($event, true)"
            :control="control"
            :var-group="dropdownVarList"
            :compare-method="compareMethod"
            :disabled="disabled"
          ></var-group-selector>
          <template v-else>
            <normal-select
              v-if="['radio', 'select', 'option'].includes(control._type)"
              class="main-value"
              :select-list="optionControlSelectList"
              :selected-item="localValue"
              @update:selectedItem="emitVal"
              multiple
              :size="size"
              :disabled="disabled"
            ></normal-select>
            <select-ref
              v-else-if="control._type == 'ref'"
              v-loading="loading"
              :disabled="disabled"
              :value="refSheetDataArr"
              :control="control"
              @input="emitVal"
              class="main-value"
              :size="size"
              multiple
            ></select-ref>
            <address-selector
              v-if="control._type == 'area'"
              :value="localValue"
              @input="emitVal"
              :disabled="disabled"
              :level="control.level"
              multiple
              :check-strictly="['包含(模糊)', '在...中'].includes(compareMethod)"
              size="mini"
              class="main-value"
            ></address-selector>
          </template>
        </template>
      </template>
      <el-input v-else value="此类型还没开发" class="main-value" disabled></el-input>
    </section>
    <template v-if="addFlowVarBtnVisible">
      <el-tooltip
        effect="dark"
        :content="from !== 'board_query' ? '使用本流程节点对象的值' : '使用本查询条件的值'"
        placement="top"
      >
        <group-dropdown-menu :group-list="dropdownVarList" @select="selectVar" :disabled="disabled">
          <div class="btn-add buttonSelectTrigger">
            <i class="el-icon-plus"></i>
          </div>
        </group-dropdown-menu>
      </el-tooltip>
    </template>
    <el-tooltip effect="dark" v-if="tip" :content="tip" placement="top-end">
      <i class="el-icon-warning icon-tip"></i>
    </el-tooltip>
    <time-select-dialog
      ref="timeSelectDialog"
      :control="control"
      :disabled="disabled"
      :compare-method="compareMethod"
      :dropdown-var-list="dropdownVarList"
      :value-var-map="valueVarMap"
      :var-label-map="varLabelMap"
      @input="emitVal"
    ></time-select-dialog>
  </div>
</template>

<script>
import AddressSelector from "@/components/AddressSelector"
import UserSelector from "@/components/FormControl/UserSelector"
import CompanySelector from "@/components/FormControl/CompanySelector"
import NormalSelect from "@/components/UIComponents/NormalSelect"
import GroupDropdownMenu from "@/components/UIComponents/GroupDropdownMenu/GroupDropdownMenu"
import SelectScope from "@/components/UIComponents/SelectScope"
import VarGroupSelector from "@/components/UIComponents/VarGroupSelector"
import { noValCompareMethod, timeRange } from "~/data/static"
import { dateTypes, timeTypes } from "./static"
import { getCompareMethods } from "@/utils/workFlow"
import { getCompanyUsers, getDepartmentTree } from "@/api/userCenter/company"
import DepartmentSelector from "@/components/FormControl/DepartmentSelector"
import { transTreeToArr } from "@/utils/user"
import { getAllConnectedCompany } from "@/api/connect"
import mixin from "./mixin"
import { getSheetViewData } from "@/api/sheet/sheetView"
import { timeTypeList } from "@/views/Backend/AdminEdit/Sheet/Field/detail-setting-content/control-setting/static"
import { needDelSpaceList } from "./static"
import { isValidObjectId, isObject, getDateExpression } from "@/utils/common"
import { getDistinctTextValueList } from "@/api/bi"
import TimeSelectDialog from "@/components/UIComponents/ConditionList/TimeSelectDialog"
import DmSelect from "@/components/BaseComponents/DmSelect"

export default {
  name: "compare-value",
  components: {
    TimeSelectDialog,
    DepartmentSelector,
    CompanySelector,
    AddressSelector,
    NormalSelect,
    UserSelector,
    GroupDropdownMenu,
    SelectScope,
    VarGroupSelector,
    DmSelect
  },
  mixins: [mixin],
  data() {
    return {
      needDelSpaceList,
      dateTypes,
      timeTypes,
      noValCompareMethod,
      timeRange,
      timeTypeList,
      refSheetDataArr: [], // 关联表控件需要特殊处理
      loading: false,
      nextTickValue: null, // 可动态添加选项的el-select控件的值需要异步设置,否则无法正确渲染
      users: [],
      companies: [],
      rootDepartment: [],
      remoteOptions: []
    }
  },
  props: {
    control: Object,
    compareMethod: String,
    value: Array,
    disabled: { type: Boolean, default: false },
    dropdownVarList: Array,
    varLabelMap: Object,
    from: String,
    departFrom: String,
    hideTip: Boolean,
    size: String,
    appRoles: Array,
    companyRoles: Array,
    sheetId: String
  },
  watch: {
    localValue: {
      immediate: true,
      handler() {
        // 可动态添加选项的el-select控件的值需要异步设置,否则无法正确渲染
        this.$nextTick(() => (this.nextTickValue = this.localValue))
        // 当前控件是关联表(不是应用和企业角色),并且值是ObjectId数组时,初始化 refSheetDataArr
        if (
          this.control._type === "ref" &&
          !["rids", "crids"].includes(this.control._cid) &&
          this._.isEmpty(this.dropdownVarList)
        ) {
          let dataIds = this.localValue.filter(id => isValidObjectId(id))
          if (!this._.isEmpty(dataIds)) {
            this.loading = true
            getSheetViewData({
              sheetId: this.control.refSheetId,
              dataIds: dataIds,
              size: dataIds.length
            })
              .then(rsp => {
                this.refSheetDataArr = (rsp.content || []).map(item => ({
                  value: item.id,
                  label: item.title
                }))
              })
              .finally(() => (this.loading = false))
          } else {
            this.refSheetDataArr = []
          }
        }
      }
    },
    "control._type": {
      immediate: true,
      handler() {
        if (this.control._type === "staff") {
          getCompanyUsers().then(users => (this.users = users)) // 延迟获取所有人员的请求,提高加载速度
        }
      }
    },
    "control._cid": {
      immediate: true,
      handler() {
        if (this.compareType === "String" && this.control._type !== "address") this.remoteMethod()
      }
    }
  },
  computed: {
    showTime() {
      let result = null
      if (
        this.control._type === "time" &&
        !["在期间", "前...天内", "后...天内"].includes(this.compareMethod)
      ) {
        if (typeof this.localValue === "object")
          result =
            "系统当前时间" +
            getDateExpression("年", this.localValue.value.years) +
            getDateExpression("月", this.localValue.value.months) +
            getDateExpression("日", this.localValue.value.days) +
            getDateExpression("时", this.localValue.value.hours) +
            getDateExpression("分", this.localValue.value.minutes) +
            getDateExpression("秒", this.localValue.value.seconds)
        else if (this.varLabelMap[this.localValue]) result = this.varLabelMap[this.localValue]
        else result = this.localValue
      }
      return result
    },
    localValue() {
      let value = (this.value || []).map(varItem => varItem.value)
      let controlType = this.control._type
      if (this.compareType === "String") {
        if (controlType === "address") return value[0]?.split("-") || []
      }
      if (this.compareType === "Number") {
        if (["date", "time"].includes(controlType)) {
          let data = value[0] || ""
          if (isObject(data)) return JSON.parse(data)
          else return data
        }
        return value[0] || undefined
      }
      if (this.compareType === "Select") {
        if (controlType === "area") return value.map(address => address.split("-"))
        if (controlType === "staff" && !this._.isEmpty(this.dropdownVarList)) {
          return value.map(userStr => ({
            label: this.userMap[userStr]?.name || this.varLabelMap[userStr] || "选项不存在",
            value: userStr,
            type: "user"
          }))
        }
        if (controlType === "department" && !this._.isEmpty(this.dropdownVarList)) {
          return value.map(dptStr => ({
            label: this.departmentMap[dptStr]?.name || this.varLabelMap[dptStr] || "选项不存在",
            value: dptStr,
            type: "department"
          }))
        }
        if (controlType === "company" && !this._.isEmpty(this.dropdownVarList)) {
          return value.map(companyStr => ({
            label:
              this.companyMap[companyStr]?.name || this.varLabelMap[companyStr] || "选项不存在",
            value: companyStr,
            type: "user"
          }))
        }
      }
      return value
    },
    compareType() {
      let { compareType } =
        this.control._cid === "id"
          ? { compareType: "String" }
          : getCompareMethods({ type: this.control._type, from: this.from })
      return compareType
    },
    tip() {
      if (this.hideTip) return null
      if (!this.compareMethod) return null
      if (this.compareType == "String" && "address" !== this.control._type) {
        return "当选择多个值，则表示是其中任意一个值时，即符合条件"
      }
      if (
        this.compareType == "Select" &&
        ["option", "staff", "company"].includes(this.control._type)
      ) {
        return "条件为包含时，表示是其中任意一个值时，符合条件；条件为不包含时，表示不包含所选值时，符合条件。"
      }
      return null
    },
    addFlowVarBtnVisible() {
      if (!this.compareMethod) return false
      if (!["String", "Number"].includes(this.compareType)) return false
      if (
        noValCompareMethod.concat(["在期间", "前...天内", "后...天内"]).includes(this.compareMethod)
      )
        return false
      if (this.from == "sheet_frontend" && !["string", "number"].includes(this.control._dataType))
        return false
      if (
        this.from == "sheet_frontend" &&
        this.control._dataType === "string" &&
        !["是", "不是"].includes(this.compareMethod)
      )
        return false
      if (this.control._type === "time") return false
      return true
    },
    stringSelectOptions() {
      return (this.value || []).map(varItem => ({
        label: varItem.var ? this.varLabelMap[varItem.value] || varItem.value : varItem.value,
        value: varItem.value
      }))
    },
    allOptions() {
      return this._.uniqBy(this.remoteOptions.concat(this.stringSelectOptions), "value")
    },
    // 用来记录当前值是否是变量
    valueVarMap() {
      return this._.chain(this.value || [])
        .keyBy("value")
        .mapValues("var")
        .value()
    },
    userMap() {
      return this._.keyBy(this.users, "id")
    },
    companyMap() {
      return this._.keyBy(this.companies, "id")
    },
    departmentMap() {
      return this._.keyBy(transTreeToArr([this.rootDepartment]), "id")
    },
    selectScopeAdditionalTabs() {
      if (this.control._type === "company") {
        return [
          {
            label: "企业",
            value: "company",
            options: this.companies.map(({ id, name }) => ({ id, name }))
          }
        ]
      }
      return []
    },
    roles() {
      let roles = []
      if (this.control._cid === "rids") roles = this.appRoles
      if (this.control._cid === "crids") roles = this.companyRoles
      return roles.map(role => ({ label: role.name, value: role.id }))
    }
  },
  beforeCreate() {
    this.$options.components.SelectRef = require("@/components/UIComponents/ConditionList/SelectRef").default
  },
  created() {
    getDepartmentTree().then(departmentTree => (this.rootDepartment = departmentTree[0]))
    getAllConnectedCompany().then(companies => (this.companies = companies))
  },
  methods: {
    emitVal(val, noTrans = false) {
      if (noTrans) {
        this.$emit("input", val)
        return
      }
      val = (this.transVal(val) || [])
        .map(value => {
          // 普通类型的数据(使用通用按钮选择变量的控件)
          if (this._.isString(value))
            return {
              var: Boolean(this.valueVarMap[value]),
              value
            }
          // 使用独立按钮选择变量的控件(例如staff)
          if (this._.isObject(value)) return value
          return null
        })
        .filter(t => t)

      this.$emit("input", val)
    },
    transVal(val) {
      let controlType = this.control._type
      switch (this.compareType) {
        case "String":
          if (controlType === "address") return this._.isEmpty(val) ? [] : [val.join("-")]
          break
        case "Number":
          return [val]
        case "Select":
          if (controlType === "area") return (val || []).map(address => address.join("-"))
          if (controlType === "staff" && !this._.isEmpty(this.dropdownVarList))
            return (val || []).map(({ value, label }) => ({
              value: value,
              var: !this.userMap[value],
              label
            }))
          if (controlType === "department" && !this._.isEmpty(this.dropdownVarList))
            return (val || []).map(({ value, label }) => ({
              value: value,
              var: !this.departmentMap[value],
              label
            }))
          if (controlType === "company" && !this._.isEmpty(this.dropdownVarList))
            return (val || []).map(({ value, label }) => ({
              value: value,
              var: !this.companyMap[value],
              label
            }))
      }
      if (this.needDelSpaceList.includes(controlType)) {
        val = val.map(item => this._.trim(item))
      }
      return val
    },
    selectVar(item) {
      switch (this.compareType) {
        case "String":
          if (this.localValue.includes(item.value)) {
            this.$message.warning("请不要重复添加")
            return
          }
          this.emitVal(
            this.value.concat({
              var: true,
              value: item.value,
              type: isValidObjectId(item.value) ? "FIELD" : "VALUE"
            }),
            true
          )
          break
        case "Number":
          this.emitVal(
            [
              {
                var: true,
                value: item.value,
                type: isValidObjectId(item.value) ? "FIELD" : "VALUE"
              }
            ],
            true
          )
          break
      }
    },
    remoteMethod(query) {
      if (this.sheetId) {
        getDistinctTextValueList({
          searchText: query,
          controlId: this.control._cid,
          searchParam: { sheetId: this.sheetId, page: 1, size: 100, filtersList: [] }
        }).then(res => {
          this.remoteOptions = res.map(info => ({ label: info, value: info }))
        })
      } else {
        this.remoteOptions = []
      }
    },
    openTimeSelect() {
      this.$refs.timeSelectDialog.open(this.localValue)
    }
  }
}
</script>

<style lang="scss" scoped>
.compare-value {
  display: flex;
  font-size: 14px;
  .value-content {
    flex: 1;
    ::v-deep {
      .user-scope-selector-container {
        min-height: 32px;
        box-sizing: border-box;
        .value-wrapper {
          min-height: 30px;
        }
      }
      .el-input .el-input__inner {
        height: 32px;
        line-height: 32px;
      }
    }
    .var-container {
      display: flex;
      align-items: center;
      height: 40px;
      line-height: 28px;
      position: relative;
      padding: 0 10px;
      background: #f8f8f8;
      border: 1px solid #ccc;
      border-radius: 4px 0 0 4px;
      box-sizing: border-box;
      .var {
        padding: 1px 5px;
      }
      .icon-close {
        margin-left: auto;
        font-size: 16px;
        cursor: pointer;
        &:hover {
          color: #1e88e5;
        }
      }
    }
    .small {
      height: 32px;
      line-height: 28px;
    }
    .main-value {
      width: 100%;
    }
    .el-date-editor {
      width: 100%;
      margin-top: 4px;
    }
    &.has-flow-var-button {
      .main-value {
        ::v-deep {
          .el-input__inner {
            border: 1px solid #ccc;
            border-top-right-radius: 0;
            border-bottom-right-radius: 0;
            &:hover {
              border-color: #2196f3;
            }
          }
        }
      }
    }
  }
  .btn-disabled {
    background: #f6f7fa;
    cursor: not-allowed;
  }
  .btn-add {
    width: 40px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-width: 1px 1px 1px 0;
    border-style: solid;
    box-sizing: border-box;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
    border-color: #ddd;
    font-size: 20px;
    color: #9e9e9e;
    cursor: pointer;
    &:hover {
      color: #1e88e5;
    }
  }
  .icon-tip {
    width: 20px;
    padding-top: 8px;
    text-align: center;
    font-size: 16px;
    cursor: pointer;
    color: #bdbdbd;
    &:hover {
      color: #1e88e5;
    }
  }
  .time-wrapper {
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    background: white;
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 30px;
    &.disabled {
      background-color: #f5f7fa;
      border-color: #e4e7ed;
      color: #c0c4cc;
      cursor: not-allowed;
    }
    .time-tip {
      flex: 0 0 auto;
      font-size: 14px;
      color: #1989fa;
      line-height: 20px;
      padding: 0 12px;
      &.disabled {
        color: grey;
      }
    }
    .icon-close {
      padding-right: 12px;
    }
  }
  .date-popover {
    ::v-deep {
      .el-popover__reference-wrapper {
        .el-input {
          margin-top: 4px;
        }
      }
    }
  }
}
</style>
